import { NgModule } from '@angular/core';
import { LoginComponent } from './login/login.component';
import { MaterialModule } from '../material.module';
import { CommonModule } from '@angular/common';
import { AuthRoutingModule } from './auth-routes.module';
import { AuthComponent } from './auth.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from './auth.service';
import { ShowtoastComponent } from './showtoast/showtoast.component';
import { SiteloaderComponent } from './siteloader/siteloader.component';
import { LoggedoutComponent } from './loggedout/loggedout.component';
import { Initial_loaderComponent } from './initial_loader/initial_loader.component';
import {SharedModule} from '../shared/shared.module';
import { CustomthemeComponent } from './customtheme/customtheme.component';
import { ThemeComponent } from './theme/theme.component';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { GuidedTourModule, GuidedTourService } from "ngx-guided-tour";
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive'


@NgModule({
    declarations: [
     LoginComponent,
     AuthComponent, 
     ShowtoastComponent,
     SiteloaderComponent,
     LoggedoutComponent,
     Initial_loaderComponent,
     CustomthemeComponent,
     ThemeComponent
    ],
    imports: [
       CommonModule, 
       MaterialModule,
       BrowserAnimationsModule,
      // FlexLayoutModule,
       AuthRoutingModule,
       FormsModule,
       ReactiveFormsModule,
       SharedModule,
       GuidedTourModule,
       Ng2SearchPipeModule,
       NgIdleKeepaliveModule.forRoot()
    ],
    entryComponents: [
     SiteloaderComponent,
     Initial_loaderComponent,
    ],
    providers: [
        AuthService,GuidedTourService
    ]
    
})
export class AuthModule {

} 

